import React, { useEffect, useRef } from "react";

export default function TourModal({ open, onClose, onDontShowAgain }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (open && videoRef.current) {
      // Attempt autoplay (muted)
      videoRef.current.muted = true;
      const p = videoRef.current.play();
      if (p && typeof p.catch === "function") p.catch(() => {});
    }
  }, [open]);

  if (!open) return null;

  return (
    <div style={overlay} data-testid="tour-modal">
      <div style={modal}>
        <div style={topbar}>
          <div style={{ fontWeight: 900 }}>Welcome to OmniMark HQ</div>
          <button onClick={onClose} style={xBtn} aria-label="Close" data-testid="tour-close-btn">✕</button>
        </div>

        <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 13, marginTop: 4 }}>
          Quick 40-second tour — you can skip anytime.
        </div>

        <div style={videoWrap}>
          <video
            ref={videoRef}
            src="/videos/welcome-40.mp4"
            controls
            playsInline
            preload="metadata"
            style={video}
          />
        </div>

        <div style={actions}>
          <button onClick={onClose} style={btnGhost} data-testid="tour-skip-btn">Skip</button>
          <button onClick={onDontShowAgain} style={btnPrimary} data-testid="tour-dont-show-btn">
            Don't show again
          </button>
        </div>
      </div>
    </div>
  );
}

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.72)",
  display: "grid",
  placeItems: "center",
  padding: "clamp(8px, 2vw, 16px)",
  zIndex: 9999,
  overflow: "auto",
};

const modal = {
  width: "min(920px, 100%)",
  maxHeight: "calc(100vh - 24px)",
  display: "grid",
  gridTemplateRows: "auto auto minmax(0, 1fr) auto",
  borderRadius: 18,
  border: "1px solid rgba(255,255,255,0.12)",
  background: "linear-gradient(180deg, rgba(20,20,20,0.98), rgba(0,0,0,0.98))",
  boxShadow: "0 30px 80px rgba(0,0,0,0.55)",
  padding: 14,
};

const topbar = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  color: "#fff",
};

const xBtn = {
  border: "1px solid rgba(255,255,255,0.15)",
  background: "rgba(255,255,255,0.06)",
  color: "#fff",
  borderRadius: 10,
  width: 36,
  height: 36,
  cursor: "pointer",
  fontSize: 16,
};

const videoWrap = {
  marginTop: 12,
  borderRadius: 14,
  overflow: "hidden",
  border: "1px solid rgba(255,255,255,0.12)",
  background: "#000",
  minHeight: 0,
  display: "grid",
  placeItems: "center",
};

const video = {
  width: "100%",
  height: "auto",
  maxHeight: "min(62vh, 560px)",
  objectFit: "contain",
  display: "block",
};

const actions = {
  marginTop: 12,
  display: "flex",
  gap: 10,
  justifyContent: "flex-end",
};

const btnGhost = {
  borderRadius: 12,
  border: "1px solid rgba(255,255,255,0.14)",
  background: "transparent",
  color: "#fff",
  padding: "10px 14px",
  fontWeight: 900,
  cursor: "pointer",
};

const btnPrimary = {
  borderRadius: 12,
  border: "none",
  background: "#6C4AF2",
  color: "#000",
  padding: "10px 14px",
  fontWeight: 900,
  cursor: "pointer",
};
